<script>
  import sanitizeClassName from '../../utils/sanitizeClassName';
  
  let {
    headingLevel = 'h1',
    className = $bindable(''),
    itemscope = undefined,
    itemtype = undefined,
    itemprop = undefined,
    dataTestId = 'base-heading',
    children
  } = $props();

  className = sanitizeClassName(className);
</script>

{#if headingLevel === 'h1'}
  <h1 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h1>
{:else if headingLevel === 'h2'}
  <h2 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h2>
{:else if headingLevel === 'h3'}
  <h3 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h3>
{:else if headingLevel === 'h4'}
  <h4 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h4>
{:else if headingLevel === 'h5'}
  <h5 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h5>
{:else if headingLevel === 'h6'}
  <h6 class={className} data-testid={dataTestId} {itemscope} {itemtype} {itemprop}>
    {@render children?.()}
  </h6>
{/if}
